<template>
  <div class="bandPillWrapper">
    <div class="picture" @click.stop="swap_user">
      <img class="image" :src="picture" />
      <div v-if="notifications" class="dot" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex"

import picture_build_helper from "~/helpers/images/picture_build"

export default {
  computed: {
    picture: function () {
      return picture_build_helper({
        kind: "band",
        slug: this.band.has_profile_picture ? this.band.slug : undefined,
        size: "200_200",
        target: "profile_picture",
      })
    },
    ...mapState({
      BAND_IS_IN_DRAFT_FLOW: (state) => state.misc.draft.in_flow,
    }),
  },
  methods: {
    get_redir_key: function () {
      const redir = {
        "/band/homepage/": ["/draft/", "/band/sendtrack/", "/band/payin/"],
      }
      for (let key in redir) {
        if (
          redir[key].some((e) => {
            return this.$route.path.includes(e)
          })
        ) {
          return key
        }
      }
      return undefined
    },
    swap_user: function () {
      const redir_target = this.get_redir_key()

      if (this.BAND_IS_IN_DRAFT_FLOW) {
        this.SET_BAND_PATCH(this.band.id)
        this.$router.push("/") // triggers save popup's guard
      } else {
        this.PATCH_BAND(this.band.id).then(async () => {
          const has_query = Object.entries(this.$route.query).length

          if (this.$route.path.includes("/band/profile/"))
            this.$router.push("/band/profile/" + this.band.slug + "/")
          else {
            if (has_query) await this.$router.replace({ query: {} })
            if (redir_target) {
              this.RESET_DRAFT()
              this.$router.push(redir_target)
            } else this.$router.go()
          }
        })
      }
    },
    ...mapActions({
      RESET_DRAFT: "draft/RESET",
      PATCH_BAND: "user/band/PATCH",
    }),
    ...mapMutations({
      SET_BAND_PATCH: "misc/draft/SET_BAND_PATCH",
    }),
  },
  props: {
    band: {
      type: Object,
      required: true,
    },
    notifications: {
      type: Number,
      required: false,
    },
  },
}
</script>

<style scoped src="./bandPill.css"></style>
